import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";import styled from '@emotion/styled'
import {PALETTE} from '../../styles/paletteV3'
import {Card} from '../../types/constEnums'
import CreateCardRootStyles from '../CreateCard/CreateCardRootStyles'
import Ellipsis from '../Ellipsis/Ellipsis'

const CardBlock = styled('div')({
  ...CreateCardRootStyles,
  border: 0
})

const AddingHint = styled('div')({
  color: PALETTE.SLATE_600,
  fontSize: Card.FONT_SIZE,
  textAlign: 'center',
  overflowWrap: 'break-word',
  overflow: 'visible',
  width: '100%'
})






const NullCard = (props) => {
  const {className, preferredName} = props
  return (
    _jsx(CardBlock, { className: className, children: 
      _jsxs(AddingHint, { children: [
        preferredName
        , ' is adding a Task'
        , _jsx(Ellipsis, {} )
      ]})
    })
  )
}

export default NullCard
